__turbopack_context__.v({
  "ManualHero": "fZuZzq_ManualHero",
  "ManualHero__Heading": "fZuZzq_ManualHero__Heading",
  "ManualHero__Image": "fZuZzq_ManualHero__Image",
  "ManualHero__Intro": "fZuZzq_ManualHero__Intro",
  "ManualHero__Logo": "fZuZzq_ManualHero__Logo",
});
